import React from "react";
import PropTypes from "prop-types";
import { Table } from "antd";
import UserAccess from "../common/user-access";
import { toDateString, toPatentDetailLink } from "../../helpers/converters";

const PatentsRelated = props => {
  const columns = [
    {
      title: "Patent Number",
      dataIndex: "grant_number",
      key: "grant_number",
      width: 150,
      render: toPatentDetailLink
    },
    {
      title: "Patent Title",
      dataIndex: "title",
      key: "title"
    },
    {
      title: "Priority Date",
      dataIndex: "priority_date",
      key: "priority_date",
      render: toDateString,
      width: 150
    }
  ];
  return (
    <UserAccess isPublicSignupAllowed={true}>
      <Table dataSource={props.data} columns={columns} rowKey="grant_number" pagination={false} scroll={{ x: 800 }} size="small" />
    </UserAccess>
  );
};

PatentsRelated.propTypes = {
  data: PropTypes.array.isRequired
};

export default PatentsRelated;
